import { atom, selector } from "recoil";
import { IsUser } from "../type/user";

// const localStorageEffect =
//   (key: string) =>
//   ({ setSelf, onSet }: any) => {
//     const savedValue = localStorage.getItem(key);
//     if (savedValue !== null) {
//       setSelf(JSON.parse(savedValue));
//     }
//     onSet((newValue: any, _: any, isReset: boolean) => {
//       isReset
//         ? localStorage.removeItem(key)
//         : localStorage.setItem(key, JSON.stringify(newValue));
//     });
//   };

export const userState = atom<IsUser>({
  key: "userState",
  default: {
    uid: "",
    username: "",
    email: "",
    emailVerified: false,
    level: 0,
    scrapAlbum: [""],
    scrapUser: [""],
    requestLevelUp: false,
    createdTime: null,
  },
  // effects: [localStorageEffect("user")],
});

export const userStateSelector = selector({
  key: "userStateSelector",
  get: ({ get }) => {
    const result = get(userState);

    return result;
  },
  set: ({ set }, newValue) => {
    set(userState, newValue);
  },
});
